import type { Options as KyOptions } from 'ky';

import { extendedKy } from 'src/services/api/ky';

/**
 * A wrapper around the extended ky client which forces all devs to use the same function call signatures.
 * @param path Omit the base URL, it will be added automatically. Also, don't include a leading slash.
 * @example apiClient('api/landloard/leads')
 */
export const apiClient = (path: string, options?: KyOptions) => extendedKy(path, options);